import { Component, ElementRef, OnInit } from '@angular/core';
import { InceptionService, TranslationService } from '@proximus/ng-common';

@Component({
  selector: 'mprd-public-wifi-details',
  templateUrl: './public-wifi-details.component.html',
  styleUrls: ['./public-wifi-details.component.css'],
})
export class PublicWifiDetailsComponent implements OnInit {
  backUrlFromApp: string;

  constructor(
    private inceptionService: InceptionService,
    private translationService: TranslationService,
    private elementRef: ElementRef,
  ) {}

  ngOnInit() {
    if (window['MyProximusMobileApp']) {
      this.backUrlFromApp = this.translationService.getTranslatedValueFor(
        'common.myproximus.back.url',
      );
    }
    setTimeout(() => {
      this.inceptionService.panelAccordion(this.elementRef);
      this.inceptionService.init();
    });
    this.scrollToTop();
  }

  private scrollToTop(): void {
    setTimeout(() => {
      this.inceptionService.scrollToElement('#publicWifiDetails');
    });
  }

  goBack() {
    this.backUrlFromApp
      ? window.open(this.backUrlFromApp)
      : window.history.back();
  }
}
